/* eslint-disable camelcase */
import NProgress from 'nprogress'
import qs from 'query-string'
import React, {useEffect, useRef} from 'react'
import {Route, withRouter} from 'react-router'

import {fetchDataBeforeRender} from '~/utils/fetchDataBeforeRender'

import 'nprogress/nprogress.css'

function PendingNavDataLoader({location, routes, store, children}) {
  // const [previousLocation, setPreviousLocation] = useState(null)
  const locationRef = useRef(location)
  useEffect(() => {
    const navigate = locationRef.current !== location
    if (navigate) {
      // setPreviousLocation(locationRef.current)
      fetchDataBeforeRender({
        store,
        routes,
        query: qs.parse(location.search),
        url: location.pathname,
        onProgress: ({progress}) => {
          NProgress.set(progress)
        },
      }).then(() => {
        // setPreviousLocation(null)
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location])
  return (
    <Route
      location={location}
      // location 发生变化时，强制 children 刷新
      render={children}
    />
  )
}

export default withRouter<any, any>(PendingNavDataLoader)
